//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { CustomerContractReference } from '../../graphql/entities';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { ICustomerContractReference } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';

const CUSTOMER_CONTRACT_REFERENCE_FIELD_NAMES: Array<Paths<ICustomerContractReference>> = [
  'reference',
  'description',
  'commencementDate',
  'expiryDate',
];

const CustomerContractReferenceWorkspace = (props: any) => {
  const workspaceProps = useWorkspace<ICustomerContractReference>(props, CustomerContractReference, {
    columns: CUSTOMER_CONTRACT_REFERENCE_FIELD_NAMES,
    initialSortColumn: 'reference',
  });

  return (
    <Workspace
      title={CustomerContractReference.title}
      formUrl={CustomerContractReference.formUrl}
      defaultQuery={CustomerContractReference.workspace}
      {...workspaceProps}
      {...props}
      entity={CustomerContractReference}
      entityType={CustomerContractReference.type}
    />
  );
};

export default CustomerContractReferenceWorkspace;
